// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import { registerServiceWorker } from "./lib/pwa"

// Service worker нужен и тем, кто ничего не устанавливал: без него браузер не
// считает сайт устанавливаемым и не покажет предложение установки.
registerServiceWorker()
